export default __webpack_public_path__ + "locales/zh-CN/Webhooks.json?hash=16598501d92d085e3574455bc1872d68";